/**
 * Umsatzsteigerung in Prozent — abgeleitet, nie gespeichert.
 *
 * **Warum es diese Funktion gibt.** Die Steigerung ist keine eigene Größe,
 * sondern eine Sicht auf zwei andere: Zielumsatz gegen Vorjahresumsatz. Sie
 * wurde trotzdem als eigene Spalte gespeichert — und driftete ab, sobald sich
 * der Vorjahresumsatz änderte. Genau das ist am 2026-08-12 passiert: Seit die
 * Abgänge im Bestand bleiben, zählt der Vorjahresumsatz auch die Kunden mit,
 * deren letztes Projekt im Vorjahr endete. Er stieg, das gespeicherte Prozent
 * blieb stehen, und die Zielpflege behauptete 17 %, wo 10,2 % richtig waren
 * (aufgefallen 2026-08-20).
 *
 * Die gespeicherten Spalten bleiben unangetastet — sie werden nur nicht mehr
 * angezeigt. Ein abgeleiteter Wert darf keine zweite Wahrheit haben.
 *
 * Gerundet auf eine Nachkommastelle, wie die Oberfläche es zeigt.
 */
export function wachstumProzent(
  zielUmsatz: number | null | undefined,
  vorjahresUmsatz: number | null | undefined,
): number | null {
  if (zielUmsatz == null || vorjahresUmsatz == null) return null;
  // Ohne Vorjahresumsatz gibt es keine Steigerung, sondern einen Anfang.
  // Eine Division durch null lieferte Infinity — eine Zahl, die aussieht wie
  // ein Ergebnis und keines ist.
  if (vorjahresUmsatz <= 0) return null;
  return Math.round((zielUmsatz / vorjahresUmsatz - 1) * 1000) / 10;
}
